import { get } from 'lodash';
import { instance } from './api.service';

const toRange = ([start, end]) => [start.toISOString(), end.toISOString()];

export const getAdminKpis = async ({ range, orderDef }) => {
  const resp = await instance.post('/admindashboard/kpis', { range: toRange(range), orderDef });
  return get(resp, 'data.counts', {});
};

export const getDeliveriesByRoute = async ({ range, orderDef }) => {
  const resp = await instance.post('/admindashboard/deliveries-by-route', { range: toRange(range), orderDef });
  return get(resp, 'data.rows', []);
};

export const getAdminRecent = async ({ range, completedLimit = 10, rejectedLimit = 10, exceptionLimit = 10, orderDef }) => {
  const resp = await instance.post('/admindashboard/recent', {
    range: toRange(range),
    completedLimit,
    rejectedLimit,
    exceptionLimit,
    orderDef,
  });
  return {
    completed: get(resp, 'data.completed', []),
    rejected: get(resp, 'data.rejected', []),
    exceptions: get(resp, 'data.exceptions', []),
  };
};

export const getAdminDeliveriesByDay = async ({ range, orderDef }) => {
  const resp = await instance.post('/admindashboard/deliveries-by-day', { range: toRange(range), orderDef });
  return get(resp, 'data.series', []);
};

export const getAdminTopLocations = async ({ range, limit = 10, orderDef }) => {
  const resp = await instance.post('/admindashboard/top-locations', { range: toRange(range), limit, orderDef });
  return get(resp, 'data.rows', []);
};

export const getAdminTopCustomers = async ({ range, limit = 20, orderDef }) => {
  const resp = await instance.post('/admindashboard/top-customers', { range: toRange(range), limit, orderDef });
  return get(resp, 'data.rows', []);
};

export const getAdminOrdersInRange = async ({ range, statuses, orderDef, includeDeleted }) => {
  const resp = await instance.post('/admindashboard/orders-in-range', { range: toRange(range), statuses, orderDef, includeDeleted });
  return get(resp, 'data.orders', []);
};

export const getAdminReturns = async ({ range, limit = 500, orderDef }) => {
  const resp = await instance.post('/admindashboard/returns', { range: toRange(range), limit, orderDef });
  return {
    cashReturns: get(resp, 'data.cashReturns', []),
    rejectionReturns: get(resp, 'data.rejectionReturns', []),
    scheduledPaymentPickups: get(resp, 'data.scheduledPaymentPickups', []),
  };
};

export const getVehicleMaintenance = async () => {
  const resp = await instance.post('/admindashboard/vehicle-maintenance', {});
  return {
    rows: get(resp, 'data.rows', []),
    intervals: get(resp, 'data.intervals', {}),
  };
};

// Card #242 — driver licence expirations. Severity ('red' | 'orange' | null)
// is computed server-side per date cell, same as vehicle maintenance above.
export const getDriverLicenses = async () => {
  const resp = await instance.post('/admindashboard/driver-licenses', {});
  return {
    rows: get(resp, 'data.rows', []),
    enabled: !!get(resp, 'data.enabled', false),
  };
};

export const updateVehicleMileage = async ({ vehicleId, mileage }) => {
  const resp = await instance.post('/admindashboard/update-mileage', { vehicleId, mileage });
  return get(resp, 'data', {});
};
